module.exports = __webpack_public_path__ + "seasonal_chic-christmas_1.jpg";